import { isSupportedLocale, setDefaultError } from '@docue/builder/i18n'

export default defineNuxtPlugin((nuxtApp) => {
  const locale = (nuxtApp.$i18n as any).locale as ComputedRef<string>

  watch(locale, (locale) => {
    isSupportedLocale(locale)
      ? setDefaultError(locale)
      : console.warn(`Locale unsupported by @docue/builder: ${locale}`)
  }, { immediate: true })
})
